// Tiny KML writer (LineString + optional Placemarks for waypoints) so users
// can grab a KML mirror of any route without a server round-trip. Mirrors
// the GeometryResponse shape (track + waypoints).

import type { TrackPoint, Waypoint } from '@xingroute/schema'

function esc(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

export function toKml(points: TrackPoint[], name: string, waypoints: Waypoint[] = []): string {
  const coords = points
    .map((p) => `${p.lon.toFixed(6)},${p.lat.toFixed(6)},${(p.ele ?? 0).toFixed(1)}`)
    .join(' ')
  const wptPlacemarks = waypoints
    .map(
      (w) => `    <Placemark>
      <name>${esc(w.name ?? 'Waypoint')}</name>
      ${w.desc ? `<description>${esc(w.desc)}</description>` : ''}
      <Point>
        <coordinates>${w.lon.toFixed(6)},${w.lat.toFixed(6)},${(w.ele ?? 0).toFixed(1)}</coordinates>
      </Point>
    </Placemark>`,
    )
    .join('\n')
  const linePlacemark =
    points.length > 0
      ? `    <Placemark>
      <name>${esc(name)}</name>
      <styleUrl>#xr-track</styleUrl>
      <LineString>
        <tessellate>1</tessellate>
        <altitudeMode>clampToGround</altitudeMode>
        <coordinates>${coords}</coordinates>
      </LineString>
    </Placemark>`
      : ''
  return `<?xml version="1.0" encoding="UTF-8"?>
<kml xmlns="http://www.opengis.net/kml/2.2">
  <Document>
    <name>${esc(name)}</name>
    <Style id="xr-track">
      <LineStyle><color>ff3a7a0a</color><width>3</width></LineStyle>
    </Style>
${linePlacemark}
${wptPlacemarks}
  </Document>
</kml>
`
}

export function triggerHrefDownload(href: string, filename: string) {
  const a = document.createElement('a')
  a.href = href
  a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()
}

export function safeDownloadBasename(name: string, fallback: string): string {
  const cleaned = name
    .normalize('NFKD')
    .replace(/[^\w.-]+/g, '-')
    .replace(/^-+|-+$/g, '')
  return cleaned || fallback
}

export function triggerDownload(filename: string, mime: string, body: BlobPart) {
  const blob = new Blob([body], { type: mime })
  const url = URL.createObjectURL(blob)
  triggerHrefDownload(url, filename)
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}
